import React, { useEffect, useState } from "react";
import { AddUsersWrapper } from "./styled";
import Breadcrumbs from "../../../components/admin/Breadcrumbs/Breadcrumbs";
import {
  BackButton,
  Box,
  ButtonStyled,
  TabsList,
} from "../../../components/styled/Elements";
import { tempUserFormTabs } from "../../../helpers/adminConstants/AdminConstants";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ContentWrapper } from "../../../components/styled/styled";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import UsersApi from "../../../services/api/usersApi";
import { toast } from "react-toastify";

const AddTemporaryUser = () => {
  const navigate = useNavigate();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const location = useLocation();
  const importedUsers = location.state?.importedUsers || [];
  const {
    register,
    control,
    handleSubmit,
    trigger,
    watch,
    resetField,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      users: importedUsers?.map((user) => ({
        phone: String(user?.phone) || "",
      })),
    },
  });

  const [activeTab, setActiveTab] = useState(tempUserFormTabs[0]);
  const [previewImg, setPreviewImg] = useState(null);
  const [secondPreviewImg, setSecondPreviewImg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [remainingLimit, setRemainingLimit] = useState(null);
  const [permissions, setPermissions] = useState({});
  const [userSections, setUserSections] = useState([0]);
  const currentTabIndex = tempUserFormTabs.findIndex(
    (tab) => tab.id === activeTab.id
  );
  const handleTabChange = async (tabIndex) => {
    const fieldsToValidate = userSections.flatMap((index) => [
      `users[${index}].name`,
      `users[${index}].email`,
      `users[${index}].phone`,
    ]);

    const isValid = await trigger(fieldsToValidate, { shouldFocus: true });
    if (isValid) {
      setActiveTab(tempUserFormTabs[tabIndex]);
    }
  };

  const handleNext = async () => {
    const fieldsToValidate = userSections.flatMap((index) => [
      `users[${index}].name`,
      `users[${index}].email`,
      `users[${index}].phone`,
    ]);

    const isValid = await trigger(fieldsToValidate, { shouldFocus: true });
    if (isValid) {
      setActiveTab(tempUserFormTabs[currentTabIndex + 1]);
    }
  };

  const addAnotherUser = () => {
    setUserSections((prev) => [...prev, prev.length]);
  };

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const formData = new FormData();

      userSections?.forEach((_, sectIndex) => {
        const user = data?.users?.[sectIndex];

        formData.append(`users[${sectIndex}][action]`, "create");
        formData.append(`users[${sectIndex}][name]`, user?.name);
        formData.append(`users[${sectIndex}][email]`, user?.email);
        formData.append(`users[${sectIndex}][phone]`, user?.phone);
        // formData.append(`users[${sectIndex}][profile]`, user?.profile);

        formData.append(`profile[${sectIndex}]`, user?.profile);
      });

      formData.append("cabinet_shared", JSON.stringify(permissions));

      const { code, message, error } = await UsersApi.createTemporaryUser(
        formData
      );

      if (code === 200) {
        toast.success(message);
        navigate("/temporary-users");
      } else if (code === 204 || code === 100) {
        toast.error(message);
      } else if (code === 429) {
        if (userSections?.length > 0) {
          toast.error(t("user_limit_exceeded", { count: remainingLimit }));
        } else {
          toast.error(error);
        }
      } else if (code === 500 && error) {
        toast.error(error);
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const checkUserLimit = async () => {
    try {
      // setIsCheckingLimit(true);
      const { code, message, data } = await UsersApi.getTempUserLimit();
      if (data && data?.max_allowed && data?.current_active) {
        setRemainingLimit(data?.max_allowed - data?.current_active);
      }
      if (code === 429) {
        toast.error(message);
        navigate("/temporary-users");
      }
    } catch (error) {
    } finally {
      // setIsCheckingLimit(false);
    }
  };
  useEffect(() => {
    checkUserLimit();
  }, []);

  useEffect(() => {
    if (importedUsers.length > 0) {
      setUserSections(
        Array.from({ length: importedUsers.length }, (_, i) => i)
      );
      importedUsers.forEach((user, index) => {
        setValue(`users.${index}.name`, user.name);
        setValue(`users.${index}.email`, user.email);
        setValue(`users.${index}.phone`, String(user.phone));
        // Add other fields similarly
      });
    }
  }, [importedUsers]);

  return (
    <AddUsersWrapper>
      <Box className="content-head">
        <Box className="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 gap-md-5">
          <BackButton
            label={t("add_temporary_user")}
            onClick={() => navigate("/temporary-users")}
          />
          <Breadcrumbs />
        </Box>
      </Box>

      <Box>
        <TabsList
          tabs={tempUserFormTabs}
          activeTab={activeTab}
          handleTabChange={handleTabChange}
        />
      </Box>
      <ContentWrapper>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <activeTab.component
            register={register}
            control={control}
            errors={errors}
            watch={watch}
            resetField={resetField}
            setValue={setValue}
            previewImg={previewImg}
            setPreviewImg={setPreviewImg}
            secondPreviewImg={secondPreviewImg}
            setSecondPreviewImg={setSecondPreviewImg}
            permissions={permissions}
            setPermissions={setPermissions}
            userSections={userSections}
            setUserSections={setUserSections}
          />
          <Box className="d-flex justify-content-between mx-3 mx-lg-5 py-4">
            <ButtonStyled
              label={t("back")}
              bg="var(--themeColor2)"
              type="button"
              onClick={() => setActiveTab(tempUserFormTabs[0])}
              disabled={activeTab === tempUserFormTabs[0]}
            />
            {activeTab === tempUserFormTabs[0] && (
              <Box className="addAnotherUserBtn">
                <ButtonStyled
                  label={t("add_another_user")}
                  onClick={addAnotherUser}
                />
              </Box>
            )}
            {activeTab === tempUserFormTabs[0] && (
              <ButtonStyled
                label={t("next")}
                type="button"
                bg="var(--themeColor2)"
                onClick={handleNext}
              />
            )}

            {activeTab === tempUserFormTabs[1] && (
              <ButtonStyled
                type="submit"
                label={t("save_create")}
                isLoading={loading}
                disabled={Object.keys(permissions).length === 0}
              />
            )}
          </Box>
        </Form>
      </ContentWrapper>
    </AddUsersWrapper>
  );
};

export default AddTemporaryUser;
